import { v4 as uuid, v5 as uuidv5 }       from 'uuid';
import React, { FC, useEffect, useState } from 'react';
import { LDProvider }                     from 'launchdarkly-react-client-sdk';
import { ProviderConfig }                 from 'launchdarkly-react-client-sdk/lib/types';

import { CorvalLDUser, LDIdentificationFields, useCurrentUser, usePrevious } from '../../../../hooks';
import { ENVIRONMENT_IS_PRODUCTION, ENVIRONMENT_IS_STAGING }                 from '../../../../constants/SystemEnums';

enum LAUNCH_DARKLY_ENV_IDS {
	TEST = '6115666d63357b25ca802df3',
	PROD = '6115666d63357b25ca802df4',
}

interface Props extends Omit<ProviderConfig, 'clientSideID'> {}

const defaultProps: Props = {}

const LaunchDarkly: FC<Props> = ( props ) => {
	
	let { currentUser, getLDUserIdentification, getLDAnonymousIdentification } = useCurrentUser(),
	    prevCurrentUser                                                        = usePrevious( currentUser ),
	    [ providerKey, setProviderKey ]                                        = useState( uuid() );
	
	useEffect( () => {
		
		// semaphore for the currentUser evaluation
		if( !prevCurrentUser?.id && currentUser?.id ){
			setProviderKey( uuid() );
		}
		
	}, [ currentUser ] );
	
	let featureFlagUser: CorvalLDUser = currentUser
	                                    ? getLDUserIdentification()
	                                    : getLDAnonymousIdentification();
	
	return (
		<LDProvider
			key={ providerKey }
			clientSideID={
				( ENVIRONMENT_IS_PRODUCTION || ENVIRONMENT_IS_STAGING )
				? LAUNCH_DARKLY_ENV_IDS.PROD
				: LAUNCH_DARKLY_ENV_IDS.TEST
			}
			user={ featureFlagUser }>
			
			{ props.children }
		
		</LDProvider>
	);
	
}

LaunchDarkly.defaultProps = defaultProps;

export { LaunchDarkly }
